// Si esta venta debía terminar con un `Sale` registrado. Un `saleId` ausente significa dos cosas
// opuestas —falló el cierre, o esta venta nunca tuvo paso 09— y cada una necesita otra pantalla.
import { hasAccountOpeningMark } from './accountOpening';
import type { WizardSession } from './types';

type SaleShape = Pick<WizardSession, 'paymentMethodKind' | 'state'> &
    Partial<Pick<WizardSession, 'payment' | 'accountOpening'>>;

/**
 * ¿Esta venta debía quedar registrada?
 *
 * No en la derivación a una financiera externa: salta del 04/05 directo a la Bienvenida sin pasar
 * por la entrega y nunca corre `completeSale`. Con extras cobrados aquí sí se registra.
 *
 * La derivación escribe las dos marcas juntas y ninguna se revierte, así que basta cualquiera de las
 * dos; se miran ambas para no depender de qué campo mande el silo el día que alguna cambie.
 */
export function expectsSaleRegistration(session: SaleShape): boolean {
    // La apertura de cuenta nunca registra venta.
    if (hasAccountOpeningMark(session)) return false;
    if (session.state === 'PAUSED_EXTERNAL_REFERRAL') return false;
    return session.paymentMethodKind !== 'EXTERNAL' || session.payment !== undefined;
}

/** Debía registrarse y no tiene referencia: el registro falta de verdad y hay que reintentarlo. */
export function saleRegistrationMissing(session: SaleShape & { saleId?: string }): boolean {
    return expectsSaleRegistration(session) && !session.saleId;
}
